export const LD_FLAG_PAYMENT_INTEGRITY_CLIENT = 'tempPaymentIntegrityWorkflows';
export const LD_FLAG_PAYMENT_INTEGRITY_SERVER = 'temp-payment-integrity-workflows';
export const LD_FLAG_ALLOW_USE_EXISTING_HPL = 'idsbPortalAllowUseExistingHpls';
export const LD_FLAG_DEMAND_ID_VALIDATION = 'idsbPortalDemandIdValidation';
export const LD_FLAG_ACTION_CENTER_PAUSE_WORKFLOW = 'idsbPortalActionCenterPauseWorkflow';
export const LD_FLAG_ACTION_CENTER_MANAGE_EMBEDDED = 'idsbPortalActionCenterManageEmbedded';
export const LD_FLAG_RM_V2_MIGRATION = 'enabledRmV2Migration';
export const LD_FLAG_ACTION_CENTER_REDELIVER_CHARTS = 'idsbPortalActionCenterRedeliverCharts';
export const LD_FLAG_ACTION_CENTER_CONTACT_INFO = 'idsbPortalActionCenterContactInfoUpdate';
export const LD_FLAG_ACTION_CENTER_RBAC_IMPORT = 'idsbPortalActionCenterRbacImport';
export const LD_FLAG_ACTION_CENTER_USER_LOOKUP = 'idsbPortalActionCenterUserLookup';
export const LD_FLAG_ACTION_CENTER_USER_LOOKUP_FILTERS = 'idsbPortalActionCenterUserLookupFilters';
export const LD_FLAG_ALLOW_EDIT_BASE_SFTP_PATH = 'idsbPortalAllowEditingBaseSftpFilePath';
export const LD_FLAG_SHOW_CHART_QA_HISTORY = 'idsbPortalShowChartQaHistory';
export const LD_FLAG_ORDER_EDIT_DETAILS = 'idsbPortalOrderEditDetails';
export const LD_FLAG_RM_V2_WARNING_PHASE = 'enabledRmV2MigrationWarningPhase';
export const LD_FLAG_RM_V2_FINAL_PHASE = 'enabledRmV2MigrationFinalPhase';
export const LD_FLAG_ACTION_CENTER_PASSWORD_RESET = 'idsbPortalActionCenterPasswordReset';
export const LD_FLAG_RM_V2_PROVISION_ON_MARK_INVITED = 'idsbTenantapiRmV2ProvisionOnMarkInvited';
export const LD_FLAG_RM_UPLOAD_PROXY = 'idsbPortalRmUploadProxy';
